"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTypography = exports.StyledMasterTypography = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const theme_1 = require("@icr-ui/theme");
exports.StyledMasterTypography = styled_components_1.default.p `
  ${({ colorScheme = {
    type: 'text',
    color: 'primary',
}, customStyles = {}, }) => {
    return (0, styled_components_1.css) `
      font-family: 'Inter', sans-serif;
      transition: all 0.2s ease-in-out;
      color: ${colorScheme.type === 'text'
        ? theme_1.palette.text[colorScheme.color]
        : theme_1.palette.system[colorScheme.color]};
      ${{ ...customStyles }}
    `;
}}
`;
exports.StyledTypography = (0, styled_components_1.default)(exports.StyledMasterTypography) `
  ${({ variant = 'body', size = 'normal', weight = 'light', isRequired = false, ...rest }) => {
    const fontVariant = theme_1.fonts[variant];
    const fontSizeProps = fontVariant[size];
    const weightProps = theme_1.fonts.body.weights[weight];
    return (0, styled_components_1.css) `
      font-size: ${fontSizeProps.fontSize};
      line-height: ${fontSizeProps.lineHeight};
      font-weight: ${variant === 'body' ? weightProps : fontSizeProps.fontWeight};
      ${!!Object.keys(rest).filter(key => key.startsWith('gutter')) &&
        (0, styled_components_1.css) `
        display: inline-block;
      `}
      ${rest.gutterBottom &&
        (0, styled_components_1.css) `
        margin-bottom: ${rest.gutterBottom};
      `}
      ${rest.gutterTop &&
        (0, styled_components_1.css) `
        margin-top: ${rest.gutterTop};
      `}
      ${rest.gutterLeft &&
        (0, styled_components_1.css) `
        margin-left: ${rest.gutterLeft};
      `}
      ${rest.gutterRight &&
        (0, styled_components_1.css) `
        margin-right: ${rest.gutterRight};
      `}
      ${rest.gutterVertical &&
        (0, styled_components_1.css) `
        margin-block: ${rest.gutterVertical};
      `}
      ${rest.gutterHorizontal &&
        (0, styled_components_1.css) `
        margin-inline: ${rest.gutterHorizontal};
      `}
      ${rest.customStyles && { ...rest.customStyles }}
      ${isRequired &&
        (0, styled_components_1.css) `
        &:after {
          content: '*';
          color: ${theme_1.palette.system.error};
          margin-left: 0.2rem;
        }
      `}
    `;
}}
`;
//# sourceMappingURL=styles.js.map